import { createAsyncActionType } from './index';

export const LINE_CHART_GET = createAsyncActionType(
  'widgets',
  'LINE_CHART_GET'
);

export const BAR_CHART_GET = createAsyncActionType('widgets', 'BAR_CHART_GET');

export const DOUGHNUT_CHART_GET = createAsyncActionType(
  'widgets',
  'DOUGHNUT_CHART_GET'
);
